import React from "react"

import Navbar from "./components/navbar/Navbar"
import Homepage from "./components/homepage/Homepage"
import Section2 from "./components/section-2/Section2"
import Section3 from "./components/section-3/Section3"
import Section4 from "./components/section-4/Section4"
import CallToAction from "./components/callToAction/CallToAction"
import Footer from "./components/footer/Footer"

const App = () => {
  return (
    <main className="app">
      <Navbar />
      <Homepage />
      <Section2 />
      <Section3 />
      <Section4 />
      <CallToAction />
      <Footer />
    </main>
  )
}

export default App
